import {AfterViewInit, Component, ElementRef, OnDestroy, OnInit, ViewChild} from "@angular/core";
import {DisposeMixin, EmptyClassInstance} from "../shared-library/mixins/dispose.mixin";
import {ExternalConfigurationService} from "../shared-library/services/configuration/external-configuration.service";
import {BrowserWindowService} from "../shared-library/services/environment/browser-window.service";
import {
    QueryStringSerializationService
} from "../shared-library/services/environment/query-string-serialization.service";
import {SavedSearchesResultModel} from "./models/saved-searches-result.model";
import {PaginationOptionsModel} from "../shared-library/form-controls/pagination/pagination-options.model";
import {SavedSearchesForm} from "./forms/saved-searches.form";
import {PaginationOptionsFactoryService} from "../advanced-search/services/pagination-options-factory.service";
import {SavedSearchesParametersFactoryService} from "./services/saved-searches-parameters-factory.service";
import {Subscription} from "rxjs";
import {SavedSearchesParametersModel} from "./models/saved-searches-parameters.model";
import {SavedSearchesService} from "./services/saved-searches.service";

@Component({
    selector: "pcg-ng-saved-searches",
    template: require('./saved-searches.component.html')
})
export class SavedSearchesComponent extends DisposeMixin(EmptyClassInstance) implements OnInit, OnDestroy, AfterViewInit {
    public savedSearchesForm: SavedSearchesForm;
    public savedSearchResults: SavedSearchesResultModel;
    public paginationOptions: PaginationOptionsModel;
    private _formSubmittedSubscription: Subscription;

    public constructor(
        private _domElement: ElementRef,
        private _configurationService: ExternalConfigurationService<SavedSearchesComponent>,
        private _paginationOptionsFactory: PaginationOptionsFactoryService,
        private _searchParametersFactory: SavedSearchesParametersFactoryService,
        private _browserWindowService: BrowserWindowService,
        private _serializationService: QueryStringSerializationService,
        private _searchService: SavedSearchesService
    ) {
        super();
    }
    public ngOnInit(): void {
        this.paginationOptions = this._paginationOptionsFactory.createDefaultPaginationOptions();

        const initialSearchParams = this._searchParametersFactory.createFromQueryString(this._browserWindowService.getQueryString());
        const emptySearchParams = this._searchParametersFactory.createFromQueryString("");
        this.savedSearchesForm = SavedSearchesForm.createForm(initialSearchParams, emptySearchParams);

        this.savedSearchesForm.instance.valueChanges.subscribe( (searchParams: SavedSearchesParametersModel) => {
            return this.invokeSearch(searchParams);
        });

        this._formSubmittedSubscription = this.savedSearchesForm.onFormSubmitted.subscribe(
            (searchParams: SavedSearchesParametersModel) => {
                return this.invokeSearch(searchParams);
            }
        );

        this._searchService.savedSearchesChanged.subscribe(
            () => {
                this.savedSearchesForm.submit();
            }
        );
        this.invokeSearch(initialSearchParams);
    }
    public ngOnDestroy(): void {
        this.dispose();
        this.savedSearchesForm.dispose();
    }

    private invokeSearch(searchParams: SavedSearchesParametersModel): void {
        this._browserWindowService.setQueryString(this._searchParametersFactory.serialiseToQueryString(searchParams));

        this.savedSearchResults = this._searchService.getSearchResults(searchParams);
        window.scrollTo(0, 0);
    }
    public ngAfterViewInit(): void {
        this.savedSearchesForm.submit();
    }
}
